// components/EventSiteInfoWrap.tsx

import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { EventInfo } from "../../types/interfaces/EventInfo";
import { EventSiteInfoWrapCss } from "./EventSiteInfoCss";
import "./EventSiteInfoWrap.css";

const EventSiteInfoWrapLeft = (info: EventInfo) => {
  return (
    <div
      className="event-site-info-wrap bg-black-2 section-pt-90 section-pb-90"
      style={EventSiteInfoWrapCss.mainContainer}
    >
      <Container>
        <Row className="align-items-center">
          <Col lg={5}>
            <div className="event-site-img">
              <Image width={"100%"} src={info.imageUrl} alt="" />
            </div>
          </Col>
          <Col lg={7}>
            <div className="event-site-info-content info-width-1">
              <h2 className="title">{info.title}</h2>
              <h3 className="sub-title">{info.subText}</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EventSiteInfoWrapLeft;
